/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as ResetPasswordRouteImport } from "./routes/reset-password";
import { Route as LoginRouteImport } from "./routes/login";
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated";
import { Route as AuthenticatedIndexRouteImport } from "./routes/_authenticated/index";
import { Route as AuthenticatedStorageIndexRouteImport } from "./routes/_authenticated/storage/index";
import { Route as AuthenticatedServiceIndexRouteImport } from "./routes/_authenticated/service/index";
import { Route as AuthenticatedSalesIndexRouteImport } from "./routes/_authenticated/sales/index";
import { Route as AuthenticatedReportsIndexRouteImport } from "./routes/_authenticated/reports/index";
import { Route as AuthenticatedMarketingIndexRouteImport } from "./routes/_authenticated/marketing/index";
import { Route as AuthenticatedInventoryIndexRouteImport } from "./routes/_authenticated/inventory/index";
import { Route as AuthenticatedInspectionIndexRouteImport } from "./routes/_authenticated/inspection/index";
import { Route as AuthenticatedFinanceIndexRouteImport } from "./routes/_authenticated/finance/index";
import { Route as AuthenticatedStorageSlipIdRouteImport } from "./routes/_authenticated/storage/$slipId";
import { Route as AuthenticatedSettingsSecurityRouteImport } from "./routes/_authenticated/settings/security";
import { Route as AuthenticatedSettingsAccountRouteImport } from "./routes/_authenticated/settings/account";
import { Route as AuthenticatedServiceReferenceRouteImport } from "./routes/_authenticated/service/reference";
import { Route as AuthenticatedServicePartsRouteImport } from "./routes/_authenticated/service/parts";
import { Route as AuthenticatedServiceCalendarRouteImport } from "./routes/_authenticated/service/calendar";
import { Route as AuthenticatedServiceWorkOrderIdRouteImport } from "./routes/_authenticated/service/$workOrderId";
import { Route as AuthenticatedSalesCustomerIdRouteImport } from "./routes/_authenticated/sales/$customerId";
import { Route as AuthenticatedMarketingCampaignIdRouteImport } from "./routes/_authenticated/marketing/$campaignId";
import { Route as AuthenticatedInventoryBoatIdRouteImport } from "./routes/_authenticated/inventory/$boatId";
import { Route as AuthenticatedInspectionInspectionIdRouteImport } from "./routes/_authenticated/inspection/$inspectionId";
import { Route as AuthenticatedServicePurchaseOrdersIndexRouteImport } from "./routes/_authenticated/service/purchase-orders.index";
import { Route as AuthenticatedServicePurchaseOrdersPoIdRouteImport } from "./routes/_authenticated/service/purchase-orders.$poId";
import { Route as AuthenticatedSalesDealsDealIdRouteImport } from "./routes/_authenticated/sales/deals/$dealId";
import { Route as AuthenticatedInventoryConsignmentConsignmentIdRouteImport } from "./routes/_authenticated/inventory/consignment/$consignmentId";

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedStorageIndexRoute =
  AuthenticatedStorageIndexRouteImport.update({
    id: "/storage/",
    path: "/storage/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedServiceIndexRoute =
  AuthenticatedServiceIndexRouteImport.update({
    id: "/service/",
    path: "/service/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSalesIndexRoute = AuthenticatedSalesIndexRouteImport.update({
  id: "/sales/",
  path: "/sales/",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: "/reports/",
    path: "/reports/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedMarketingIndexRoute =
  AuthenticatedMarketingIndexRouteImport.update({
    id: "/marketing/",
    path: "/marketing/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedInventoryIndexRoute =
  AuthenticatedInventoryIndexRouteImport.update({
    id: "/inventory/",
    path: "/inventory/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedInspectionIndexRoute =
  AuthenticatedInspectionIndexRouteImport.update({
    id: "/inspection/",
    path: "/inspection/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedFinanceIndexRoute =
  AuthenticatedFinanceIndexRouteImport.update({
    id: "/finance/",
    path: "/finance/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedStorageSlipIdRoute =
  AuthenticatedStorageSlipIdRouteImport.update({
    id: "/storage/$slipId",
    path: "/storage/$slipId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsSecurityRoute =
  AuthenticatedSettingsSecurityRouteImport.update({
    id: "/settings/security",
    path: "/settings/security",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: "/settings/account",
    path: "/settings/account",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedServiceReferenceRoute =
  AuthenticatedServiceReferenceRouteImport.update({
    id: "/service/reference",
    path: "/service/reference",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedServicePartsRoute =
  AuthenticatedServicePartsRouteImport.update({
    id: "/service/parts",
    path: "/service/parts",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedServiceCalendarRoute =
  AuthenticatedServiceCalendarRouteImport.update({
    id: "/service/calendar",
    path: "/service/calendar",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedServiceWorkOrderIdRoute =
  AuthenticatedServiceWorkOrderIdRouteImport.update({
    id: "/service/$workOrderId",
    path: "/service/$workOrderId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSalesCustomerIdRoute =
  AuthenticatedSalesCustomerIdRouteImport.update({
    id: "/sales/$customerId",
    path: "/sales/$customerId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedMarketingCampaignIdRoute =
  AuthenticatedMarketingCampaignIdRouteImport.update({
    id: "/marketing/$campaignId",
    path: "/marketing/$campaignId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedInventoryBoatIdRoute =
  AuthenticatedInventoryBoatIdRouteImport.update({
    id: "/inventory/$boatId",
    path: "/inventory/$boatId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedInspectionInspectionIdRoute =
  AuthenticatedInspectionInspectionIdRouteImport.update({
    id: "/inspection/$inspectionId",
    path: "/inspection/$inspectionId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedServicePurchaseOrdersIndexRoute =
  AuthenticatedServicePurchaseOrdersIndexRouteImport.update({
    id: "/service/purchase-orders/",
    path: "/service/purchase-orders/",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedServicePurchaseOrdersPoIdRoute =
  AuthenticatedServicePurchaseOrdersPoIdRouteImport.update({
    id: "/service/purchase-orders/$poId",
    path: "/service/purchase-orders/$poId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedSalesDealsDealIdRoute =
  AuthenticatedSalesDealsDealIdRouteImport.update({
    id: "/sales/deals/$dealId",
    path: "/sales/deals/$dealId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedInventoryConsignmentConsignmentIdRoute =
  AuthenticatedInventoryConsignmentConsignmentIdRouteImport.update({
    id: "/inventory/consignment/$consignmentId",
    path: "/inventory/consignment/$consignmentId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof AuthenticatedIndexRoute;
  "/login": typeof LoginRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/inspection/$inspectionId": typeof AuthenticatedInspectionInspectionIdRoute;
  "/inventory/$boatId": typeof AuthenticatedInventoryBoatIdRoute;
  "/marketing/$campaignId": typeof AuthenticatedMarketingCampaignIdRoute;
  "/sales/$customerId": typeof AuthenticatedSalesCustomerIdRoute;
  "/service/$workOrderId": typeof AuthenticatedServiceWorkOrderIdRoute;
  "/service/calendar": typeof AuthenticatedServiceCalendarRoute;
  "/service/parts": typeof AuthenticatedServicePartsRoute;
  "/service/reference": typeof AuthenticatedServiceReferenceRoute;
  "/settings/account": typeof AuthenticatedSettingsAccountRoute;
  "/settings/security": typeof AuthenticatedSettingsSecurityRoute;
  "/storage/$slipId": typeof AuthenticatedStorageSlipIdRoute;
  "/finance/": typeof AuthenticatedFinanceIndexRoute;
  "/inspection/": typeof AuthenticatedInspectionIndexRoute;
  "/inventory/": typeof AuthenticatedInventoryIndexRoute;
  "/marketing/": typeof AuthenticatedMarketingIndexRoute;
  "/reports/": typeof AuthenticatedReportsIndexRoute;
  "/sales/": typeof AuthenticatedSalesIndexRoute;
  "/service/": typeof AuthenticatedServiceIndexRoute;
  "/storage/": typeof AuthenticatedStorageIndexRoute;
  "/inventory/consignment/$consignmentId": typeof AuthenticatedInventoryConsignmentConsignmentIdRoute;
  "/sales/deals/$dealId": typeof AuthenticatedSalesDealsDealIdRoute;
  "/service/purchase-orders/$poId": typeof AuthenticatedServicePurchaseOrdersPoIdRoute;
  "/service/purchase-orders/": typeof AuthenticatedServicePurchaseOrdersIndexRoute;
}
export interface FileRoutesByTo {
  "/login": typeof LoginRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/": typeof AuthenticatedIndexRoute;
  "/inspection/$inspectionId": typeof AuthenticatedInspectionInspectionIdRoute;
  "/inventory/$boatId": typeof AuthenticatedInventoryBoatIdRoute;
  "/marketing/$campaignId": typeof AuthenticatedMarketingCampaignIdRoute;
  "/sales/$customerId": typeof AuthenticatedSalesCustomerIdRoute;
  "/service/$workOrderId": typeof AuthenticatedServiceWorkOrderIdRoute;
  "/service/calendar": typeof AuthenticatedServiceCalendarRoute;
  "/service/parts": typeof AuthenticatedServicePartsRoute;
  "/service/reference": typeof AuthenticatedServiceReferenceRoute;
  "/settings/account": typeof AuthenticatedSettingsAccountRoute;
  "/settings/security": typeof AuthenticatedSettingsSecurityRoute;
  "/storage/$slipId": typeof AuthenticatedStorageSlipIdRoute;
  "/finance": typeof AuthenticatedFinanceIndexRoute;
  "/inspection": typeof AuthenticatedInspectionIndexRoute;
  "/inventory": typeof AuthenticatedInventoryIndexRoute;
  "/marketing": typeof AuthenticatedMarketingIndexRoute;
  "/reports": typeof AuthenticatedReportsIndexRoute;
  "/sales": typeof AuthenticatedSalesIndexRoute;
  "/service": typeof AuthenticatedServiceIndexRoute;
  "/storage": typeof AuthenticatedStorageIndexRoute;
  "/inventory/consignment/$consignmentId": typeof AuthenticatedInventoryConsignmentConsignmentIdRoute;
  "/sales/deals/$dealId": typeof AuthenticatedSalesDealsDealIdRoute;
  "/service/purchase-orders/$poId": typeof AuthenticatedServicePurchaseOrdersPoIdRoute;
  "/service/purchase-orders": typeof AuthenticatedServicePurchaseOrdersIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/_authenticated": typeof AuthenticatedRouteWithChildren;
  "/login": typeof LoginRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/_authenticated/": typeof AuthenticatedIndexRoute;
  "/_authenticated/inspection/$inspectionId": typeof AuthenticatedInspectionInspectionIdRoute;
  "/_authenticated/inventory/$boatId": typeof AuthenticatedInventoryBoatIdRoute;
  "/_authenticated/marketing/$campaignId": typeof AuthenticatedMarketingCampaignIdRoute;
  "/_authenticated/sales/$customerId": typeof AuthenticatedSalesCustomerIdRoute;
  "/_authenticated/service/$workOrderId": typeof AuthenticatedServiceWorkOrderIdRoute;
  "/_authenticated/service/calendar": typeof AuthenticatedServiceCalendarRoute;
  "/_authenticated/service/parts": typeof AuthenticatedServicePartsRoute;
  "/_authenticated/service/reference": typeof AuthenticatedServiceReferenceRoute;
  "/_authenticated/settings/account": typeof AuthenticatedSettingsAccountRoute;
  "/_authenticated/settings/security": typeof AuthenticatedSettingsSecurityRoute;
  "/_authenticated/storage/$slipId": typeof AuthenticatedStorageSlipIdRoute;
  "/_authenticated/finance/": typeof AuthenticatedFinanceIndexRoute;
  "/_authenticated/inspection/": typeof AuthenticatedInspectionIndexRoute;
  "/_authenticated/inventory/": typeof AuthenticatedInventoryIndexRoute;
  "/_authenticated/marketing/": typeof AuthenticatedMarketingIndexRoute;
  "/_authenticated/reports/": typeof AuthenticatedReportsIndexRoute;
  "/_authenticated/sales/": typeof AuthenticatedSalesIndexRoute;
  "/_authenticated/service/": typeof AuthenticatedServiceIndexRoute;
  "/_authenticated/storage/": typeof AuthenticatedStorageIndexRoute;
  "/_authenticated/inventory/consignment/$consignmentId": typeof AuthenticatedInventoryConsignmentConsignmentIdRoute;
  "/_authenticated/sales/deals/$dealId": typeof AuthenticatedSalesDealsDealIdRoute;
  "/_authenticated/service/purchase-orders/$poId": typeof AuthenticatedServicePurchaseOrdersPoIdRoute;
  "/_authenticated/service/purchase-orders/": typeof AuthenticatedServicePurchaseOrdersIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/login"
    | "/reset-password"
    | "/inspection/$inspectionId"
    | "/inventory/$boatId"
    | "/marketing/$campaignId"
    | "/sales/$customerId"
    | "/service/$workOrderId"
    | "/service/calendar"
    | "/service/parts"
    | "/service/reference"
    | "/settings/account"
    | "/settings/security"
    | "/storage/$slipId"
    | "/finance/"
    | "/inspection/"
    | "/inventory/"
    | "/marketing/"
    | "/reports/"
    | "/sales/"
    | "/service/"
    | "/storage/"
    | "/inventory/consignment/$consignmentId"
    | "/sales/deals/$dealId"
    | "/service/purchase-orders/$poId"
    | "/service/purchase-orders/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/login"
    | "/reset-password"
    | "/"
    | "/inspection/$inspectionId"
    | "/inventory/$boatId"
    | "/marketing/$campaignId"
    | "/sales/$customerId"
    | "/service/$workOrderId"
    | "/service/calendar"
    | "/service/parts"
    | "/service/reference"
    | "/settings/account"
    | "/settings/security"
    | "/storage/$slipId"
    | "/finance"
    | "/inspection"
    | "/inventory"
    | "/marketing"
    | "/reports"
    | "/sales"
    | "/service"
    | "/storage"
    | "/inventory/consignment/$consignmentId"
    | "/sales/deals/$dealId"
    | "/service/purchase-orders/$poId"
    | "/service/purchase-orders";
  id:
    | "__root__"
    | "/_authenticated"
    | "/login"
    | "/reset-password"
    | "/_authenticated/"
    | "/_authenticated/inspection/$inspectionId"
    | "/_authenticated/inventory/$boatId"
    | "/_authenticated/marketing/$campaignId"
    | "/_authenticated/sales/$customerId"
    | "/_authenticated/service/$workOrderId"
    | "/_authenticated/service/calendar"
    | "/_authenticated/service/parts"
    | "/_authenticated/service/reference"
    | "/_authenticated/settings/account"
    | "/_authenticated/settings/security"
    | "/_authenticated/storage/$slipId"
    | "/_authenticated/finance/"
    | "/_authenticated/inspection/"
    | "/_authenticated/inventory/"
    | "/_authenticated/marketing/"
    | "/_authenticated/reports/"
    | "/_authenticated/sales/"
    | "/_authenticated/service/"
    | "/_authenticated/storage/"
    | "/_authenticated/inventory/consignment/$consignmentId"
    | "/_authenticated/sales/deals/$dealId"
    | "/_authenticated/service/purchase-orders/$poId"
    | "/_authenticated/service/purchase-orders/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  LoginRoute: typeof LoginRoute;
  ResetPasswordRoute: typeof ResetPasswordRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/reset-password": {
      id: "/reset-password";
      path: "/reset-password";
      fullPath: "/reset-password";
      preLoaderRoute: typeof ResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated": {
      id: "/_authenticated";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/": {
      id: "/_authenticated/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/storage/": {
      id: "/_authenticated/storage/";
      path: "/storage";
      fullPath: "/storage/";
      preLoaderRoute: typeof AuthenticatedStorageIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/service/": {
      id: "/_authenticated/service/";
      path: "/service";
      fullPath: "/service/";
      preLoaderRoute: typeof AuthenticatedServiceIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/sales/": {
      id: "/_authenticated/sales/";
      path: "/sales";
      fullPath: "/sales/";
      preLoaderRoute: typeof AuthenticatedSalesIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/reports/": {
      id: "/_authenticated/reports/";
      path: "/reports";
      fullPath: "/reports/";
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/marketing/": {
      id: "/_authenticated/marketing/";
      path: "/marketing";
      fullPath: "/marketing/";
      preLoaderRoute: typeof AuthenticatedMarketingIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/inventory/": {
      id: "/_authenticated/inventory/";
      path: "/inventory";
      fullPath: "/inventory/";
      preLoaderRoute: typeof AuthenticatedInventoryIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/inspection/": {
      id: "/_authenticated/inspection/";
      path: "/inspection";
      fullPath: "/inspection/";
      preLoaderRoute: typeof AuthenticatedInspectionIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/finance/": {
      id: "/_authenticated/finance/";
      path: "/finance";
      fullPath: "/finance/";
      preLoaderRoute: typeof AuthenticatedFinanceIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/storage/$slipId": {
      id: "/_authenticated/storage/$slipId";
      path: "/storage/$slipId";
      fullPath: "/storage/$slipId";
      preLoaderRoute: typeof AuthenticatedStorageSlipIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/settings/security": {
      id: "/_authenticated/settings/security";
      path: "/settings/security";
      fullPath: "/settings/security";
      preLoaderRoute: typeof AuthenticatedSettingsSecurityRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/settings/account": {
      id: "/_authenticated/settings/account";
      path: "/settings/account";
      fullPath: "/settings/account";
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/service/reference": {
      id: "/_authenticated/service/reference";
      path: "/service/reference";
      fullPath: "/service/reference";
      preLoaderRoute: typeof AuthenticatedServiceReferenceRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/service/parts": {
      id: "/_authenticated/service/parts";
      path: "/service/parts";
      fullPath: "/service/parts";
      preLoaderRoute: typeof AuthenticatedServicePartsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/service/calendar": {
      id: "/_authenticated/service/calendar";
      path: "/service/calendar";
      fullPath: "/service/calendar";
      preLoaderRoute: typeof AuthenticatedServiceCalendarRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/service/$workOrderId": {
      id: "/_authenticated/service/$workOrderId";
      path: "/service/$workOrderId";
      fullPath: "/service/$workOrderId";
      preLoaderRoute: typeof AuthenticatedServiceWorkOrderIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/sales/$customerId": {
      id: "/_authenticated/sales/$customerId";
      path: "/sales/$customerId";
      fullPath: "/sales/$customerId";
      preLoaderRoute: typeof AuthenticatedSalesCustomerIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/marketing/$campaignId": {
      id: "/_authenticated/marketing/$campaignId";
      path: "/marketing/$campaignId";
      fullPath: "/marketing/$campaignId";
      preLoaderRoute: typeof AuthenticatedMarketingCampaignIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/inventory/$boatId": {
      id: "/_authenticated/inventory/$boatId";
      path: "/inventory/$boatId";
      fullPath: "/inventory/$boatId";
      preLoaderRoute: typeof AuthenticatedInventoryBoatIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/inspection/$inspectionId": {
      id: "/_authenticated/inspection/$inspectionId";
      path: "/inspection/$inspectionId";
      fullPath: "/inspection/$inspectionId";
      preLoaderRoute: typeof AuthenticatedInspectionInspectionIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/service/purchase-orders/": {
      id: "/_authenticated/service/purchase-orders/";
      path: "/service/purchase-orders";
      fullPath: "/service/purchase-orders/";
      preLoaderRoute: typeof AuthenticatedServicePurchaseOrdersIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/service/purchase-orders/$poId": {
      id: "/_authenticated/service/purchase-orders/$poId";
      path: "/service/purchase-orders/$poId";
      fullPath: "/service/purchase-orders/$poId";
      preLoaderRoute: typeof AuthenticatedServicePurchaseOrdersPoIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/sales/deals/$dealId": {
      id: "/_authenticated/sales/deals/$dealId";
      path: "/sales/deals/$dealId";
      fullPath: "/sales/deals/$dealId";
      preLoaderRoute: typeof AuthenticatedSalesDealsDealIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/inventory/consignment/$consignmentId": {
      id: "/_authenticated/inventory/consignment/$consignmentId";
      path: "/inventory/consignment/$consignmentId";
      fullPath: "/inventory/consignment/$consignmentId";
      preLoaderRoute: typeof AuthenticatedInventoryConsignmentConsignmentIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute;
  AuthenticatedInspectionInspectionIdRoute: typeof AuthenticatedInspectionInspectionIdRoute;
  AuthenticatedInventoryBoatIdRoute: typeof AuthenticatedInventoryBoatIdRoute;
  AuthenticatedMarketingCampaignIdRoute: typeof AuthenticatedMarketingCampaignIdRoute;
  AuthenticatedSalesCustomerIdRoute: typeof AuthenticatedSalesCustomerIdRoute;
  AuthenticatedServiceWorkOrderIdRoute: typeof AuthenticatedServiceWorkOrderIdRoute;
  AuthenticatedServiceCalendarRoute: typeof AuthenticatedServiceCalendarRoute;
  AuthenticatedServicePartsRoute: typeof AuthenticatedServicePartsRoute;
  AuthenticatedServiceReferenceRoute: typeof AuthenticatedServiceReferenceRoute;
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute;
  AuthenticatedSettingsSecurityRoute: typeof AuthenticatedSettingsSecurityRoute;
  AuthenticatedStorageSlipIdRoute: typeof AuthenticatedStorageSlipIdRoute;
  AuthenticatedFinanceIndexRoute: typeof AuthenticatedFinanceIndexRoute;
  AuthenticatedInspectionIndexRoute: typeof AuthenticatedInspectionIndexRoute;
  AuthenticatedInventoryIndexRoute: typeof AuthenticatedInventoryIndexRoute;
  AuthenticatedMarketingIndexRoute: typeof AuthenticatedMarketingIndexRoute;
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute;
  AuthenticatedSalesIndexRoute: typeof AuthenticatedSalesIndexRoute;
  AuthenticatedServiceIndexRoute: typeof AuthenticatedServiceIndexRoute;
  AuthenticatedStorageIndexRoute: typeof AuthenticatedStorageIndexRoute;
  AuthenticatedInventoryConsignmentConsignmentIdRoute: typeof AuthenticatedInventoryConsignmentConsignmentIdRoute;
  AuthenticatedSalesDealsDealIdRoute: typeof AuthenticatedSalesDealsDealIdRoute;
  AuthenticatedServicePurchaseOrdersPoIdRoute: typeof AuthenticatedServicePurchaseOrdersPoIdRoute;
  AuthenticatedServicePurchaseOrdersIndexRoute: typeof AuthenticatedServicePurchaseOrdersIndexRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedInspectionInspectionIdRoute:
    AuthenticatedInspectionInspectionIdRoute,
  AuthenticatedInventoryBoatIdRoute: AuthenticatedInventoryBoatIdRoute,
  AuthenticatedMarketingCampaignIdRoute: AuthenticatedMarketingCampaignIdRoute,
  AuthenticatedSalesCustomerIdRoute: AuthenticatedSalesCustomerIdRoute,
  AuthenticatedServiceWorkOrderIdRoute: AuthenticatedServiceWorkOrderIdRoute,
  AuthenticatedServiceCalendarRoute: AuthenticatedServiceCalendarRoute,
  AuthenticatedServicePartsRoute: AuthenticatedServicePartsRoute,
  AuthenticatedServiceReferenceRoute: AuthenticatedServiceReferenceRoute,
  AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
  AuthenticatedSettingsSecurityRoute: AuthenticatedSettingsSecurityRoute,
  AuthenticatedStorageSlipIdRoute: AuthenticatedStorageSlipIdRoute,
  AuthenticatedFinanceIndexRoute: AuthenticatedFinanceIndexRoute,
  AuthenticatedInspectionIndexRoute: AuthenticatedInspectionIndexRoute,
  AuthenticatedInventoryIndexRoute: AuthenticatedInventoryIndexRoute,
  AuthenticatedMarketingIndexRoute: AuthenticatedMarketingIndexRoute,
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
  AuthenticatedSalesIndexRoute: AuthenticatedSalesIndexRoute,
  AuthenticatedServiceIndexRoute: AuthenticatedServiceIndexRoute,
  AuthenticatedStorageIndexRoute: AuthenticatedStorageIndexRoute,
  AuthenticatedInventoryConsignmentConsignmentIdRoute:
    AuthenticatedInventoryConsignmentConsignmentIdRoute,
  AuthenticatedSalesDealsDealIdRoute: AuthenticatedSalesDealsDealIdRoute,
  AuthenticatedServicePurchaseOrdersPoIdRoute:
    AuthenticatedServicePurchaseOrdersPoIdRoute,
  AuthenticatedServicePurchaseOrdersIndexRoute:
    AuthenticatedServicePurchaseOrdersIndexRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
